import React, {Component} from 'react';
import {Label, UncontrolledTooltip} from "reactstrap";
import {request} from "../../util/APIUtils";
import {deepCopyObject, showAxiosError, trimObject} from "../../util/Helpers";
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import {API_BASE_URL} from "../../constants";
import './OdaList.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import Select from 'react-select';

class OdaForm extends Component {

	constructor(props) {
		super(props);
		this.state = {
			error: {},
			mode: 'create',
			page: 0,
			size: 10,
			manual: false,
			loading: false,
			fieldsDisabled: false,
			branchCityList: [],
			members: null,
			selectedMembers: [], //seçilen üyeler burda saklanacak
			gorevler: null,
			oda: {
				id: null,
				ad: null,
				adres: null,
				email: null,
				kurulusKararNo: null,
				telefonNo: null,
				webSitesiURL: null,
			},
			odaUye: {
				odaId: null,
				uyeId: null,
				role: null
			}
		};

		this.validateClass = this.validateClass.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.validateField = this.validateField.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.saveOda = this.saveOda.bind(this);
		this.cancelProcess = this.cancelProcess.bind(this);
		this.getCityList = this.getCityList.bind(this);
		this.getGorevler = this.getGorevler.bind(this);
		this.listMember = this.listMember.bind(this);
		this.handleMemberChange = this.handleMemberChange.bind(this);
	}

	componentDidMount() {
		this.getGorevler();
		this.listMember(0, 10);
		if (this.props.selectedOda) {
			this.getCityList();
			let selectedOda = deepCopyObject(this.props.selectedOda);
			let mod = deepCopyObject(this.props.mode);
			let fieldsDisabled = (!(this.props.currentUser.realm === 0 || this.props.currentUser.realm === this.props.selectedOda.id));
			this.setState({
				mode: mod,
				oda: selectedOda,
				fieldsDisabled: fieldsDisabled,
			})
		}
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let value = e.target.value;
		let result = validateField(rule, boundary, value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	/*
       onChangeMember(name,value) {
        let memberInfo=this.state.memberInfo;
        (name==='email') ? memberInfo[name]=value : memberInfo[name]=value.toString().toLocaleUpperCase() ;
        this.setState({ memberInfo });
        console.log(memberInfo);
    }
    */

	onChangeOda(e) {
		this.setState({
			oda: {
				...this.state.oda,
				[e.target.name]: e.target.value.toString().toLocaleUpperCase()
			}
		})
	}

	onChangeOdaUye(e) {
		console.log(e.target.name)
		this.setState({
			odaUye: {
				...this.state.odaUye,
				[e.target.name]: e.target.value.toString().toLocaleUpperCase()
			}
		})
	}

	onChangeEmail(e) {
		this.setState({
			oda: {
				...this.state.oda,
				[e.target.name]: e.target.value
			}
		})
	}

	listMember(page, size) {
		let self = this;
		let params = {
			url: API_BASE_URL + "/uye/uyeler?page=" + page + "&size=" + size,
			method: "get",
		};

		self.setState({loading: true});
		request(params)
			.then(function (response) {
				let katilimci = response.data;
				const members = katilimci.map((katilimci) => ({
					value: katilimci.id,
					label: katilimci.ad + " " + katilimci.soyad,
				}));
				self.setState(prevState => ({
					...prevState,
					members: members,
					loading: false
				}));
			})
			.catch(function (error) {
				self.setState({
					loading: false,
					error: "Katılımcıları almak başarısız oldu.",
				});
			});
	}
	handleMemberChange(selectedMembers) {
		this.setState({ selectedMembers });
	}
	getGorevler() {
		let self = this;
		let params = {
			url: API_BASE_URL + "/oda/gorevler",
			method: "get",
		};

		console.log(params.url);
		request(params)
			.then(function (response) {
				let newGorevler = response.data;
				console.log("gorevler", newGorevler);
				self.setState(prevState => ({
					...prevState,
					gorevler: newGorevler
				}));
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	getCityList() {
		let self = this;
		let params = {
			url: API_BASE_URL + "/oda/cityList/" + this.props.selectedOda.id,
			method: "get",
		};
		console.log(params.url);
		request(params)
			.then(function (response) {
				let branchCityList = response.data;
				console.log("branchCityList", branchCityList);
				self.setState({
					branchCityList
				});
			}).catch(function (error) {
			showAxiosError(error);
		});
	}


	saveOda() {
		let self = this;
		let params;
		let data;
		let message;
		let validity = this.validateComponent();
		if (validity.valid) {
			self.setState({isLoading: true});
			let oda = deepCopyObject(this.state.oda);
			oda = trimObject(oda);
			let odaUye = deepCopyObject(this.state.odaUye);
			odaUye = trimObject(odaUye);
			odaUye['odaId'] = oda.id;
			if (this.state.mode === 'create') {
				data = oda;
			} else {
				data = {oda, odaUye}
			}
			console.log("Oda form!!!")
			console.log(data);
			if (oda.id === null) {
				message = 'Komisyon Başarıyla Kaydedildi.'
				params = {
					url: API_BASE_URL + "/oda",
					data: data,
					method: 'post'
				};
			} else {
				message = 'Komisyon Başarıyla Güncellendi.'
				params = {
					url: API_BASE_URL + "/oda",
					data: data,
					method: 'put'
				};
			}
			request(params).then(() => {
				Alert.success(
					message, {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					});
				self.setState({isLoading: false});
				this.cancelProcess();
				self.props.handleSearch();
			}).catch(function (error) {
				self.setState({isLoading: false});
				showAxiosError(error);
			});
		} else {
			Alert.error('Hatalı veya eksik alanlar var!', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}


	cancelProcess() {
		this.props.cancelProcess();
	}

	render() {
		console.log("this.state.members",this.state.members)
		return (
			<div className='oda-form-container' style={{width:"100%"}}>
				{
					(this.state.isLoading) &&
					<div className="loader">
						<LoadingIndicator/>
					</div>
				}
				<div className="card-body mt-1" style={{width:"100%"}}>
					<div className="FormRenk col-sm-12 mt-4">
						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Komisyon Adı *</label>
							</div>
							<div className="col-sm-9">
								<div className={"form-group" + this.validateClass('tAd')}>
									<input className="form-control"
										   type="text"
										   name="ad"
										   id="tAd"
										   data-vlength="1,255"
										   onBlur={this.validateField}
										   ref="tAd"
										   defaultValue={this.state.oda.ad}
										   onChange={(e) => this.onChangeOda(e)}
										   disabled={this.state.fieldsDisabled}
									/>
									{this.validateMessage('tAd') !== "" &&
										<UncontrolledTooltip placement="right" target="tAd" delay={0}>
											{this.validateMessage("tAd")}
										</UncontrolledTooltip>}
								</div>
							</div>
						</div>
						<div className='row'>
							<Label className="col-sm-3">Üye Ekle: </Label>
							<div className="col-sm-8 form-group" style={{ flex: 10 }}>
								<div className={"form-group" + this.validateClass('tUyeEkle')}>
									<Select
										className="basic-single"
										classNamePrefix="select"
										placeholder="Lütfen Üye Seçiniz"
										isClearable={false}
										isSearchable={false}
										isMulti
										name="uyeId"
										id="tUyeId"
										value={this.state.selectedMembers}
										onChange={this.handleMemberChange}
										options={this.state.members}
										styles={{
											control: (base, state) => ({
												...base,
												minHeight: '35px',
												width: '115%', // Kutucuğun yatay genişliğini ayarla
												//minWidth: '100px',// Placeholder'ın yüksekliği
											}),
										}}
										disabled={this.state.fieldsDisabled}
									/>
									{this.validateMessage('tUyeId') !== "" && (
										<UncontrolledTooltip placement="right" target="tUyeId" delay={0}>
											{this.validateMessage("tUyeId")}
										</UncontrolledTooltip>
									)}
								</div>
							</div>
						</div>

						<div className='col-sm-12 row'>
							<div className="col-sm-3">
								<label>Üye Görevi:</label>
							</div>
							<div className="col-sm-9">
								<div className={"form-group" + this.validateClass('tUyeGorevi')}>
									<select
										className="form-control"
										name="role"
										id="tRole"
										onBlur={this.validateField}
										ref="tRole"
										value={this.state.oda.uyeGorevi}
										onChange={(e) => this.onChangeOdaUye(e)}
										disabled={this.state.fieldsDisabled}
									>
										<option value="">Lütfen Üye Görevi Seçiniz</option>
										{this.state.gorevler && this.state.gorevler.map((gorev, index) => (
											<option key={index} value={gorev}>
												{gorev}
											</option>
										))}
									</select>
									{this.validateMessage('tRole') !== "" && (
										<UncontrolledTooltip placement="right" target="tRole" delay={0}>
											{this.validateMessage("tRole")}
										</UncontrolledTooltip>
									)}
								</div>
							</div>

						</div>
					</div>
				</div>
				{/* CARD FOOTER */}
				<div className="modal-footer">
					<div className='col-sm-12 row' id="deleteModal">
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"150px"}}
									rel="tooltip" className="TekBtn vazgec "
									onClick={this.cancelProcess}>
								İptal
							</button>
						</div>
						<div className="col-sm-8" />
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
										float: 'right', padding: '10px 54px 10px 23px', width:"150px"
									}}
									rel="tooltip" className="TekBtn kaydet"
									disabled={this.state.fieldsDisabled}
									onClick={() => this.saveOda()}>{this.state.mode === 'create' ? 'Onayla' : 'Kaydet'}
							</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default OdaForm;



// WEBPACK FOOTER //
// ./src/page/odaList/OdaForm.js